import { Button } from "@/components/ui/button"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"
import { cn } from "@/utils/utils"
import { MentoresType } from "@/types/mentorias"

interface MentorsTabContentProps {
  mentores: MentoresType[]
  disabledAlert: boolean
  onRateLastMentoring: () => void
  onSchedule: (calLink: string) => void
}

export function MentorsTabContent({
  mentores,
  disabledAlert,
  onRateLastMentoring,
  onSchedule,
}: MentorsTabContentProps) {
  return (
    <>
      {disabledAlert && (
        <div className="my-4 flex w-full flex-wrap items-center justify-between gap-4 rounded-sm border border-red-500 bg-red-950 p-4">
          <div>
            <h6 className="text-[1.2rem] font-bold">Atenção!</h6>
            <p>Para agendar novas mentorias, avalie a última realizada.</p>
          </div>
          <div>
            <Button onClick={onRateLastMentoring}>Avaliar última mentoria</Button>
          </div>
        </div>
      )}
      <h4 className="my-5 text-2xl font-bold">Mentores disponíveis</h4>
      <div
        style={{ "--max-width": mentores.length <= 2 ? "400px" : "1fr" } as any}
        className="grid grid-cols-[repeat(auto-fit,minmax(calc(5vw+300px),var(--max-width)))] gap-4"
      >
        {mentores.map((mentor, index) => (
          <div
            key={index}
            className="card-elevated transition-smooth flex flex-1 items-center justify-between p-5 hover:scale-[1.01]"
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <span>{mentor.nome}</span>
            <div className="flex items-center gap-4">
              {mentor.link && (
                <Tooltip>
                  <TooltipTrigger>
                    <button
                      className={cn(disabledAlert && "opacity-50")}
                      disabled={disabledAlert}
                      onClick={() => onSchedule(mentor.link)}
                    >
                      <i className="fi fi-ts-calendar" />
                    </button>
                  </TooltipTrigger>
                  <TooltipContent>Agendar Mentoria</TooltipContent>
                </Tooltip>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  )
}
